import React from 'react';

/** Длительность анимации закрытия окон сайта (совпадает с modal.module.css). */
export const MODAL_CLOSE_MS = 280;

/**
 * Держит окно в DOM, пока доигрывает анимация закрытия.
 * mounted — рендерить ли окно; closing — повесить класс закрытия.
 */
export function useModalPresence(open: boolean, closeMs: number = MODAL_CLOSE_MS) {
  const [mounted, setMounted] = React.useState(open);

  React.useEffect(() => {
    if (open) {
      setMounted(true);
      return undefined;
    }
    const timer = window.setTimeout(() => setMounted(false), closeMs);
    return () => window.clearTimeout(timer);
  }, [open, closeMs]);

  return { mounted: mounted || open, closing: mounted && !open };
}
